import { render, staticRenderFns } from "./updatamy.vue?vue&type=template&id=706bf315&"
import script from "./updatamy.vue?vue&type=script&lang=js&"
export * from "./updatamy.vue?vue&type=script&lang=js&"
import style0 from "./updatamy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports